import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Experience, AppStatus, Item, Ost, User, GisQureyResult } from '../models';
import { TranslateService } from '@ngx-translate/core';
import { Observer, fromEvent } from 'rxjs';
import { Observable } from 'rxjs';
import Event from 'ol/events/Event';
import { AppInformationService } from './appinformation.service';
import * as foo from '../../core/models/functions-cordova';

@Injectable()

export class ExpLocalStorage {

    experience: Experience;
    localItems: Item[] = [];
    localOst: Ost[] = [];

    keyExp: string = 'savedExp';
    keyItems: string = 'localItems';
    keyOst: string = 'localOst';

    constructor(
        private appService: AppInformationService,
        private translateService: TranslateService
    ) {
        if (this.getWgisCfg() === null) {
            this.setWgisCfg(
                { "styles": [{ "feature": "default", "circle": { "radius": 5, "stroke": "#0066cc", "fill": "#0066cc" }, "stroke": { "color": "#0066cc", "width": 3 }, "fill": { "color": "#0066cc" } }, { "feature": "measure", "stroke": { "color": "#0066cc", "width": 3 }, "fill": { "color": "#0066cc" } }, { "feature": "edit", "circle": { "radius": 5, "stroke": "#0066cc", "fill": "#0066cc" }, "stroke": { "color": "#0066cc", "width": 3 }, "fill": { "color": "#0066cc" } }], "engine": [{ "zorder": 1, "mapTitle": "RAS WMS", "serverType": "geoserver", "mapName": "RAS WMS", "url": "http://webgis.regione.sardegna.it/geoserverraster/ows?service=wms&version=1.3.0", "notVisible": false, "isOn": false, "icon": "fa-globe-europe", "expand": false, "params": { "CRS": "EPSG:3857", "LAYERS": "raster:ortofoto_2016" }, "hidpi": true, "isBase": true, "attributions": "Regione Autonoma della Sardegna", "projection": "EPSG:3857", "type": "WMS", "isMaster": false }, { "zorder": 2, "mapTitle": "Sfondo OSM", "mapName": "Sfondo OSM", "notVisible": false, "isOn": true, "icon": "fa-map-signs", "expand": false, "isBase": true, "projection": "EPSG:3857", "type": "OSM", "isMaster": false }, { "zorder": 6, "mapTitle": "WMAI WMS", "serverType": "qgis", "mapName": "WMAI WMS", "url": "https://wms-wmai.stage.sardegnaturismocloud.it/?SERVICE=WMS&REQUEST=GetCapabilities", "notVisible": false, "isOn": true, "icon": "fas fa-layer-group", "expand": false, "params": { "CRS": "EPSG:3857", "LAYERS": ["Regioni", "OST_lin", "SchedeIntense", "Esperienze", "OST_pt"] }, "hidpi": true, "isBase": false, "attributions": "WMAI", "projection": "EPSG:3857", "type": "WMS", "isMaster": false }, { "zorder": 7, "mapTitle": "Oggetti", "isSelection": true, "mapName": "Oggetti", "notVisible": false, "expand": false, "name": null, "projection": "EPSG:3857", "type": "VECTOR", "isMaster": true }], "view": { "center": [1012026, 5211782], "zoom": 7, "projection": "EPSG:3857" } }
            );
        }
    }
    /**
     * si ottiene l'esperienze attraverso una chiave che si è settata inizialmente attraverso la login
     */
    getExperience() {
        if (localStorage.getItem(this.keyExp) != null) {
            return this.experience = JSON.parse(localStorage.getItem(this.keyExp));
        } else {
            return null;
        }
    }
    /**
     * si ottiene l'oggetto locale attraverso una chiave che si è settata inizialmente attraverso la login
     */
    getLocalItems() {
        if (localStorage.getItem(this.keyItems) != null) {
            return this.localItems = JSON.parse(localStorage.getItem(this.keyItems));
        } else {
            return null;
        }
    }
    /**
     * si ottiene l'OSt attraverso una chiave che si è settata inizialmente attraverso la login
     */
    getLocalOst() {
        if (localStorage.getItem(this.keyOst) != null) {
            return this.localOst = JSON.parse(localStorage.getItem(this.keyOst));
        } else {
            return null;
        }
    }
  
    /**
     * si setta l'esperienza con un oggetto Experience passato come parametro
     * @param  {Experience} value
     */
    setExperience(value: Experience) {
        this.experience = value;
        localStorage.setItem(this.keyExp, JSON.stringify(value));
    }
    
    /**
     * si setta l'oggeto locale l'esperienza con il parametro preso da un array di oggetti
     * @param  {Item[]} value
     */
    setLocalItems(value: Item[]) {
        this.localItems = value;
        localStorage.setItem(this.keyItems, JSON.stringify(value));
    }
    /**
     * si setta l'oggeto locale l'esperienza con il parametro preso da un array di OSt
     * @param  {Ost[]} value
     */
    setLocalOst(value: Ost[]) {
        this.localOst = value;
        localStorage.setItem(this.keyOst, JSON.stringify(value));
    }
    /**
     * si elimina l'esperienza rimuovendola dal local storage
     */
    removeExperience() {
        this.experience = null;
        localStorage.removeItem(this.keyExp);
    }
     /**
     * si elimina l'esperienza rimuovendola dal local storage
     */
    removeLocalItems() {
        this.localItems = null;
        localStorage.removeItem(this.keyItems);
    }
    /**
     * si elimina l'OSt locale rimuovendolo dal local storage
     */
    removeLocalOst() {
        this.localOst = null;
        localStorage.removeItem(this.keyOst);
    }
    /**
     *ottiene il WgisCfg
     */
    getWgisCfg() {
        const cfg = localStorage.getItem('__Wgis_Cfg__')
        if (cfg != null) {
            return JSON.parse(cfg);
        } else {
            return null;
        }
    }
    /** 
     * si setta WgisCfg attraverso il parametro
     * @param  {any} value
     */
    setWgisCfg(value: any) {
        localStorage.setItem('__Wgis_Cfg__', JSON.stringify(value));
    }
    /**
     * si elimina WgisCfg rimuovendolo dal local storage
     */
    removeWgisCfg() {
        this.localOst = null;
        localStorage.removeItem('__Wgis_Cfg__');
    }
    /** 
     * attraverso il parametro si cerca il Local OSt
     * @param  {number} id
     */
    findLocalOst(id: number){
        this.localOst = JSON.parse(localStorage.getItem(this.keyOst));
        return this.localOst.filter(ost => ost.id == id);
    }

    clearCache(){
        var exp = this.experience;
        if(exp != null && this.appService.iAmMobile()){
          foo.removeDirFolder(exp.id.toString());
          this.removeExperience();
        }
        this.removeLocalItems();
        this.removeLocalOst();
    }

}